import React, { Fragment, useEffect, useState } from "react";
import { string } from "prop-types";
import { useLocation, useParams } from "react-router-dom";
import { ResponsiveHeader, DesktopButtons, MobileButtons } from "pages/_components/header";
import MainContainer from "pages/_components/MainContainer";
import I18n from "pages/_components/I18n";
import Button from "pages/_components/Button";
import Action from "pages/_components/Action";
import Drawer from "pages/_components/Drawer/Drawer";
import Loader from "pages/_components/Loader";
import Notification from "pages/_components/Notification";
import { useDispatch, useSelector } from "react-redux";
import { actions as echeckActions } from "reducers/echecks";
import { receivedEcheqsStatusActions, emittedEcheqsStatusActions, statusTagColor } from "util/echecks";
import { isIOS } from "react-device-detect";
import DataEcheck from "./DataEcheck";
import SeeMoreData from "./SeeMoreData";
import useActionByEcheckState from "../hooks/useActionByEcheckState";
import InfoTag from "../components/InfoTag";
import EcheckAccordion from "./EcheckAccordion";
import { useGetAccounts } from "hooks/useAccounts";

const accordionLabels = ["sign", "aval", "endorse", "reject", "cession"];

const DetailEcheck = () => {
    // const [numberToExpand, setNumberToExpand] = useState("");
    const { echeqDetail: selectedEcheck, fetching } = useSelector((state) => state.echecks);
    const { pathname } = useLocation();
    const { id } = useParams();
    const dispatch = useDispatch();
    const [actionsEcheck, setActionsEcheck] = useState(null);
    const [actionDrawer, setActionDrawer] = useState({ showDrawer: false, contentDrawer: null });
    const { accounts } = useGetAccounts();
    const { options, isExpired } = useActionByEcheckState(actionsEcheck, selectedEcheck, setActionDrawer, accounts);
    const [showMoreData, setShowMoreData] = useState(false);
    const [buttonLabel, setButtonLabel] = useState("echecks.seeMore.button");

    useEffect(() => {
        dispatch(echeckActions.requestEcheqDetail(id));
        if (pathname.includes("received")) {
            setActionsEcheck(receivedEcheqsStatusActions);
            return;
        }
        if (pathname.includes("emitted")) {
            setActionsEcheck(emittedEcheqsStatusActions);
        }
    }, []);

    if (fetching) {
        return <Loader />;
    }

    const State = ({ className }) => (
        <InfoTag
            type="info"
            message={selectedEcheck?.estado}
            tagBackground={statusTagColor(selectedEcheck?.estado)}
            tagClass={className}
        />
    );

    const title = `${"Echeq"} N° ${selectedEcheck?.cheque_numero}\u00A0`;
    State.propTypes = {
        className: string.isRequired,
    };

    const handleSeeMoreData = () => {
        setShowMoreData(!showMoreData);
        if (!showMoreData) {
            setButtonLabel("echecks.seeLess.button");
        } else {
            setButtonLabel("echecks.seeMore.button");
        }
    };
    const getAccordionData = () => ({
        sign: selectedEcheck?.firmantes,
        aval: selectedEcheck?.avalistas,
        endorse: selectedEcheck?.endosos,
        reject: selectedEcheck?.rechazos,
        cession: selectedEcheck?.cesiones,
    });

    const handleCloseActionDrawer = () => {
        setActionDrawer({ showDrawer: false, contentDrawer: null, title: "" });
    };

    return (
        <Fragment>
            <Notification scopeToShow="echecks" />
            <Notification scopeToShow="echecksMainPage" backLinkTo="echecks" />
            <ResponsiveHeader defaultTitle={title} id={title} infoComponents={<State />}>
                {options.length > 0 && !isExpired && (
                    <>
                        <DesktopButtons>
                            {options.map((option) => (
                                <Button className="btn btn-outline" onClick={option.func}>
                                    <I18n id={option.text} />
                                </Button>
                            ))}
                        </DesktopButtons>
                        <MobileButtons
                            image={isIOS ? "images/figma/icon/menu-ios-white.svg" : "images/figma/icon/menu-ios.svg"}>
                            {options.map((option) => (
                                <Action labelKey={option.text} handleClick={option.func} />
                            ))}
                        </MobileButtons>{" "}
                    </>
                )}
            </ResponsiveHeader>
            <MainContainer className="echeck" showLoader={fetching}>
                <div className="container">
                    <div className="check">
                        <DataEcheck
                            numeroCheque={title}
                            estadoCheque={<State className="data-echeck__estado" />}
                            emisorNombre={selectedEcheck?.emisor_razon_social}
                            emisorTipoDocumento={selectedEcheck?.beneficiario_documento_tipo}
                            emisorCuit={selectedEcheck?.emisor_cuit}
                            montoCheque={selectedEcheck?.monto}
                            fechaEmision={selectedEcheck?.fecha_emision}
                            fechaPago={selectedEcheck?.fecha_pago}
                            caracterCheque={selectedEcheck?.cheque_caracter}
                            beneficiarioCheque={selectedEcheck?.beneficiario_nombre}
                            beneficiarioDocumento={selectedEcheck?.beneficiario_documento}
                            CMC7={selectedEcheck?.cmc7}
                            endosos={selectedEcheck?.endosos}
                            emisorMoneda={selectedEcheck?.moneda}
                        />
                    </div>
                </div>
                <Button
                    aria-expanded={showMoreData ? "true" : "false"}
                    className="more-button"
                    label={buttonLabel}
                    bsStyle="link"
                    onClick={handleSeeMoreData}
                />
                {showMoreData && <SeeMoreData className="more-box" echeckData={selectedEcheck} />}
                <EcheckAccordion
                    labels={accordionLabels}
                    data={getAccordionData()}
                    curency={selectedEcheck?.emisor_moneda}
                />
            </MainContainer>
            <Drawer openSidebar={actionDrawer.showDrawer} onClose={handleCloseActionDrawer}>
                {actionDrawer.contentDrawer}
            </Drawer>
        </Fragment>
    );
};

export default DetailEcheck;
